// Spec schemas per category > sub-category
// Empty / undefined sub-categories fall back to free-form custom fields only

export const SPEC_SCHEMAS = {
  agricultural: {
    tractor: {
      version: 1,
      fields: [
        { key: 'travelSpeedKmh',        label: 'Travel speed (km/h)',         type: 'number', required: true },
        { key: 'engineSizeL',           label: 'Engine size (L)',             type: 'number', required: true },
        { key: 'engineOilCapacityL',    label: 'Engine oil capacity (L)',     type: 'number', required: true },
        { key: 'hydraulicOilCapacityL', label: 'Hydraulic oil capacity (L)',  type: 'number', required: true },
        { key: 'engineHp',              label: 'Engine power (hp)',           type: 'number', required: true },
        { key: 'ptoHp',                 label: 'PTO power (hp)',              type: 'number', required: true },
      ],
    },
  },
};

export function getSchemaFor(category, subCategory) {
  return SPEC_SCHEMAS?.[category]?.[subCategory] || null;
}

export function getRequiredFieldsFor(category, subCategory) {
  const schema = getSchemaFor(category, subCategory);
  if (!schema) return [];
  return schema.fields.filter(f => f.required);
}

export function isSpecsComplete(category, subCategory, specs) {
  const required = getRequiredFieldsFor(category, subCategory);
  if (required.length === 0) return false;
  return required.every(f => {
    const v = specs?.[f.key];
    return v !== undefined && v !== null && v !== '';
  });
}
